import { render, staticRenderFns } from "./newCategory.vue?vue&type=template&id=42215f22&scoped=true"
import script from "./newCategory.vue?vue&type=script&scoped=true&lang=js"
export * from "./newCategory.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./newCategory.vue?vue&type=style&index=0&id=42215f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42215f22",
  null
  
)

export default component.exports